import "./sobre.css";

import { BsPlayCircleFill } from "react-icons/bs";

export default function Sobre() {
  const skills = [
    "TRABALHO EM EQUIPE",
    "BOA COMUNICAÇÃO",
    "PROATIVIDADE",
    "VONTADE DE APRENDER",
    "CURIOSO 😁",
    "RESOLUÇÃO DE PROBLEMAS",
    "EM CONSTANTE EVOLUÇÃO"
  ];

  return (
    <section className="containerSobre">
      <div className="sobre">
        <div className="tituloSobre">
          <h3>SOBRE</h3>
          <BsPlayCircleFill size={60} color="#FFFFFF" />
        </div>

        <div className="textSobre">
          <p className="text">
          Prazer!! Me Chamo João Lucas apaixonado pela área de tecnologia! Com meus 28 anos de idade, sou um entusiasta do desenvolvimento Web FrontEnd e estou sempre em busca de novos conhecimentos para aprimorar minhas habilidades.
          </p>
          <p className="text">
          Com uma mente curiosa e inquieta, sempre em busca de novos desafios e projetos para colocar em prática meus conhecimentos e habilidades.
          </p>
          <p className="text">
          Sempre em mente que não importa a quantidade de horas que deva estudar, mas sim nunca parar e praticar todos os dias.
          </p>
        </div>
      </div>

      <div className="sobre corCard">

        <div className="tituloSobre">
          <h3 className="fontCard">SKILLS</h3>
          <BsPlayCircleFill size={60} color="#000000" />
        </div>

        <div className="textSobre flexSobre">

          {skills.map((item) => (
            <span key={item} className="tagSkill">
              {item}
            </span>
          ))}

        </div>

      </div>
    </section>
  );
}
